import { AppMainService } from '../../../../app-main.service';
import { DynamicTableWidgetService } from '../../../../modules/shared/services/dynamic-table/dynamic-table-widget.service';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DynamicTableWidgetDetailsM } from '../../../../modules/shared/models/dynamic-table/dynamic-table-widget-details.model';
import { WorkbookList } from 'src/app/misc/workspace/models/workspace.models';
import { ModuleWidgetService } from 'src/app/modules/shared/services/dynamic-table/module-widget.service';

@Component({
    selector: 'app-saved-search-added-list',
    templateUrl: './saved-search-added-list.component.html',
    styleUrl: './saved-search-added-list.component.scss'
})
export class SavedSearchAddedListComponent implements OnInit, OnDestroy {

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    @Input() displayAddedList: boolean = false;
    @Input() savedSearchId: number;
    @Input() savedSearchModuleId: number;
    @Input() savedSearchTemplateId: number;
    @Input() selectedWorkbook: WorkbookList;
    @Output() dialogClosed = new EventEmitter<boolean>();
    @Output() tabRemoved = new EventEmitter<boolean>();

    addedWidgets: DynamicTableWidgetDetailsM[] = [];

    //Edit
    selectedWidget: DynamicTableWidgetDetailsM;
    displayAddToList: boolean = false;

    constructor(
        private confirmationService: ConfirmationService,
        private messageService: MessageService,
        private appMainService: AppMainService,
        private dynamicTableWidgetService: DynamicTableWidgetService,
        private workbookService: ModuleWidgetService
    ) { }

    ngOnInit(): void {
        this.getAddedWidgets();
    }

    getAddedWidgets(){
        let referenceTypeId:number; 
        let referenceId: number;
        if(this.savedSearchId){
            referenceTypeId = 1;
            referenceId = this.savedSearchId;
        }
        else if(this.selectedWorkbook?.intId){
            referenceTypeId = 2;
            referenceId = this.selectedWorkbook?.intId;
        }
        this.appMainService.isShowSpinner('getAddedWidgets');
        this.dynamicTableWidgetService.getAddedWidgets(referenceTypeId, referenceId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response:DynamicTableWidgetDetailsM[])=>{
                this.appMainService.isHideSpinner('getAddedWidgets');
                this.addedWidgets = response || [];
            },
            error: (error)=>{
                this.appMainService.isHideSpinner('getAddedWidgets');
            }
        })
    }

    openEditList(widgetDetails: DynamicTableWidgetDetailsM){
        this.selectedWidget = widgetDetails;
        this.displayAddToList = true;
    }

    cancelToList(){
        this.displayAddToList = false;
    }

    removeAddedList(widgetDetails: DynamicTableWidgetDetailsM) {
        this.confirmationService.confirm({
            message: 'Do you want to remove this List?',
            header: 'Remove Confirmation',
            icon: 'pi pi-info-circle',
            key: 'removeAddedList',
            accept: () => {
                this.dynamicTableWidgetService.deleteWidget(widgetDetails.widgetId).subscribe({
                    next: (response)=>{
                        this.appMainService.hideAllSpinner();
                        this.addedWidgets = this.addedWidgets.filter(t=> t.widgetId!==widgetDetails.widgetId);
                        this.messageService.add({ severity: 'success', summary: 'List Removed', detail: 'List removed successfully!' });
                        this.refreshCustomModuleMenu();
                        this.tabRemoved.emit(true);
                        this.closeDialog();
                    },
                    error: (error)=>{
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: error?.error?.Message||'Error occurred while removing data...' });
                    }
                })
            },
            reject: () => {
            }
        });
    }

    refreshCustomModuleMenu() {
        this.workbookService.forceRefreshWidgets();
    }

    closeDialog() {
        this.dialogClosed.emit();
    }

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }
}
